import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Header from "./Header";
import Nav from "./Nav";
import { ROOM_DETAIL_URL, ROOM_ARRANGE_URL, ROOM_FORM_LINK } from "../actions/types.js";
import { DatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIos from "@material-ui/icons/ArrowForwardIos";
import Button from "@material-ui/core/Button";
import moment from "moment";
import "moment/locale/zh-cn";
import MomentUtils from "@date-io/moment";
// 房间的排期
class RoomArrangement extends Component {
  state = {
    date: moment(),
    room: {},
    arrangement: []
  };
  componentDidMount() {
    const { id } = this.props.match.params;
    axios({
      method: "get",
      url: `${ROOM_DETAIL_URL}/${id}`,
    }).then(res => {
      this.setState({ room: res.data });
    });
    this.getArrangement();
  }
  getArrangement() {
    const { id } = this.props.match.params;
    const { date } = this.state;
    axios({
      method: "get",
      url: `${ROOM_ARRANGE_URL}/${id}?date=${date.format("YYYY-MM-DD")}`,
    }).then(res => {
      this.setState({ arrangement: res.data });
    });
  }
  minusDate() {
    this.setState({ date: this.state.date.subtract(1, "days") }, () => this.getArrangement());
  }
  plusDate() {
    this.setState({ date: this.state.date.add(1, "days") }, () => this.getArrangement());
  }
  render() {
    const { room, date } = this.state;
    if (room.id) {
      return (
        <React.Fragment>
          <Header />
          <section className="container arrangement-section" style={{ paddingTop: 16 }}>
            <div className="arrange-name">{room.name}</div>
            <div className="arrange-date">
              <Button className="index-left-arrow" onClick={() => this.minusDate()}>
                <ArrowBackIos style={{ fontSize: "16px", marginLeft: 6 }} />
              </Button>
              <span>{date.format("MM 月 DD 日 ddd")}</span>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                  margin="normal"
                  value={date}
                  className="arrangement-date-picker"
                  cancelLabel="取消"
                  okLabel="确定"
                  onChange={e => this.handleDateChange(e)}
                />
              </MuiPickersUtilsProvider>
              <Button className="index-right-arrow" onClick={() => this.plusDate()}>
                <ArrowForwardIos style={{ fontSize: "16px" }} />
              </Button>
            </div>
            {this.state.arrangement.map((data, idx) => {
              return (
                <ExpansionPanel key={idx} className="arrange-content" in={"true"} timeout="auto">
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>
                      <span className="content-purpose">{data.purpose}</span>
                      <span className="content-date">
                        {moment(data.start).format("HH:mm")} - {moment(data.end).format("HH:mm")}
                      </span>
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Typography>
                      <span className="content-desc">{data.description}</span>
                    </Typography>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              );
            })}
            {this.state.arrangement.length === 0 && (
              <div className="arrangement-room-noArrangement">当天没有预约，马上约</div>
            )}
            <Link
              to={{ pathname: `${ROOM_FORM_LINK}`, state: { room: room, timeStamp: date.valueOf() } }}
              className="arrangement-room-reserve"
            >
              预约
            </Link>
          </section>
          <Nav />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <Header />
          <div>loading...</div>
          <Nav />
        </React.Fragment>
      );
    }
  }
}
export default RoomArrangement;
